import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import template from '../../templates/StoneSetupCard.rt';
import * as actions from '../../actions';
import $ from 'jquery';
import _ from 'lodash';
import { forceCheck } from 'react-lazyload';
import {AccessRights} from './../../schemas/accessRightsModel';
import * as misc from './../../misc';
import * as pricingPresets from './../../constants/pricingPresets';
import {toFixedPrice} from "../../utilities";

export const imageUnavailable = "data:image/png;base64,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";

function mapStateToProps(state, props) {
  const { stone } = props;
  const { masterStoneListIds } = state.stonesV2;
  let isInMaster = _.findIndex(masterStoneListIds, id => id === stone.id) >= 0;

  return {
    presets: state.pricingPreset.presets,
    stone,
    isInMaster,
    AR: AccessRights.get(state)
  };
}

function mapDispatchToProps(dispatch, { stone }) {
  return {
    onUpdateTransientField: (key, value) => dispatch(actions.updateTransientField(stone, key, _.trim(value))),
    editStone: () => dispatch(actions.newStone.showEditStonePopup(true, stone)),
    deleteStone: () => dispatch(actions.deleteStone(stone)),
    showErrorBox: (title, text) => dispatch(actions.messageBox_Show(true, 'error', title, text)),
    showMessageBox: (title, text) => dispatch(actions.messageBox_Show(true, 'system', title, text)),
    showImageUploadNotice: (preview) => dispatch(actions.newStone.showImageUploadNotice(preview)),
    showEditPricingProfile: (selectedProfile) => dispatch(actions.pricingPresets.showEdit(selectedProfile))
  };
}

class StoneSetupCardComponent extends Component {
  constructor(props) {
    super(props);

    this.setStoneCardInnerlineRef = ref => {
      this.stoneCardInnerline = ref;
    }

    this.state = {
      enabled: (props.stone.fabricatorStoneData && props.stone.fabricatorStoneData.enabled),
      price: this.getPrice(props.stone) || 0,
      image: this.getStoneImage(props.stone),
      name: this.getStoneName(props.stone),
      imageUrl: props.stone.imageUrl,
      thumbUrl: props.stone.thumbUrl,
      showReset: (props.stone.fabricatorStoneData && props.stone.fabricatorStoneData.imageKey),
      isOwner: props.AR.isMe(props.stone.createdById, false),
      setAsMaster: false
    };
  }

  _changeTimeout = [];
  onChange(key, value) {
    if(this._changeTimeout[key]) {
      window.clearTimeout(this._changeTimeout[key]);
    }
    this.setState({[key]: value}, () => {
      this._changeTimeout[key] = window.setTimeout(() => {
        this.props.onUpdateTransientField(key, value);
      }, 250);
    });
  }

  onToggleEnabled = () => this.onChange('enabled', !this.state.enabled);

  updateNameTransientField(value) {
    const { stone } = this.props;
    let trimValue = _.trim(value);
    if(trimValue.length == 0) {
      this.setState({name: stone.name});
    }
    if(trimValue.length > 45) {
      trimValue = _.trim(trimValue.substring(0, 45));
      this.setState({name: trimValue});
    }
    this.props.onUpdateTransientField('name', trimValue);
  }

  updatePriceTransientfield(value) {
    let newVal = value.replace(/[^0-9\.\-]/g, '');
    this.setState({price: newVal}, () => {
      this.props.onUpdateTransientField('price', newVal);
    });
  }


  resetImageKey() {
    this.props.onUpdateTransientField('imageKey', null);
    this.props.onUpdateTransientField('clearImage', true);

    this.setState({
      image: this.getStoneImage(this.props.stone, true),
      showReset: false
    });
  }

  getPrice(stone) {
    let price = null;
    if (stone.fabricatorStoneData && stone.fabricatorStoneData.price > 0) {
      price = stone.fabricatorStoneData.price;
    }
    let profile = this.getPricingProfile();
    let hasProfileAndShowAnyway = (profile && profile.data && profile.data[0] && profile.data[0].type == pricingPresets.PRICING_PRESET_SLAB_SEG) || false;
    if(hasProfileAndShowAnyway) {
      if(price == 0 || !stone.fabricatorStoneData.profilePriceOverride) {
        price = this.getPricingProfile().data[0].value;
      }
    }

    return price ? toFixedPrice(+price) : price
  }

  getStoneImage(stone, reset = false) {
    let imageKey = (reset || (this.state && this.state.clearImage)) ? null : (stone.fabricatorStoneData && stone.fabricatorStoneData.imageKey);
    let imageUrl = imageUnavailable;

    if(stone.thumbUrl)
      imageUrl = stone.thumbUrl;
    else if(stone.imageUrl)
      imageUrl = stone.imageUrl;

    if (imageKey)
      imageUrl = "https://s3.amazonaws.com/stone_images/sss-thumbnail-" + imageKey;

    /* creation of imageUnavailable data uri code, uncomment and adjust to update image
    if(!stone.thumbUrl) {
      let icp = document.createElement("canvas");
      icp.setAttribute("width", "240px");
      icp.setAttribute("height", "240px");
      let ctx = icp.getContext("2d");
      ctx.fillStyle = "#c6c6c6";
      ctx.fillRect(0, 0, 240, 240);
      ctx.fillStyle = "#000000";
      ctx.font = "30px Arial";
      ctx.fillText("No Image",55,100);
      ctx.fillText("Available", 60, 150);
      imageUrl = icp.toDataURL("image/png");
      console.log(stone, imageUrl);
    } */

    return imageUrl;
  }

  getStoneName(stone) {
    let customStoneName = stone.fabricatorStoneData && stone.fabricatorStoneData.customStoneName;
    let name = customStoneName || stone.name;
    if (name && _.trim(name).length === 0) {
      name = stone.name;
    }
    return name;
  }

  /**
   * Returns Preset Id
   * @return {int}
   */
  getPricingId = () => {
    let fabStoneData = this.props.stone.fabricatorStoneData || {};
    return fabStoneData.pricingPresetId;
  }

  /**
   * returns Assigned Pricing Profile Icon url
   * @return {string}
   */
  getPricingProfileIcon = () => {
    let pricingProfile = this.getPricingProfile();
    return pricingProfile && pricingProfile.icon;
  }

  getPricingProfileName = () => {
    let pricingProfile = this.getPricingProfile();
    return pricingProfile && pricingProfile.name;
  }

  editAssignedPricingProfile = (e) => {
    misc.ignoreDefault(e);
    let pricingId = this.getPricingId();
    let pricingProfile = _.find(this.props.presets, p => p.id == pricingId);
    this.props.showEditPricingProfile(pricingProfile);
  }

  /**
   * Returns if stone is assigned a Pricing Profile
   * @return {bool}
   */
  isAssignedPricingProfile = () => {
    //https://stackoverflow.com/a/784946
    return !!this.getPricingProfile();
  }

  getPricingProfile = () => {
    for(var i = 0; i < this.props.presets.length; i++) {
      var preset = this.props.presets[i];
      if(preset.id == this.getPricingId()) {
        return preset;
      }
    }
  }

  shouldShowPriceAnyway = () => {
    let profile = this.getPricingProfile();
    return (profile && profile.data && profile.data[0] && profile.data[0].type == pricingPresets.PRICING_PRESET_SLAB_SEG);
  }

  onStoneClick(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this.fileUploadNode).click();
  }

  handleFileSelect(evt) {
    var files = evt.target.files; // FileList object

    // Loop through the FileList and render image files as thumbnails.
    for (var i = 0, f; f = files[i]; i++) {
      // Only process image files.
      if (!f.type.match('image.*')) {
        continue;
      }

      var reader = new FileReader();
      // Closure to capture the file information.
      reader.onload = (function (theFile) {
        return function (e) {
          var img = new Image();
          img.onload = () => {
            var height = img.height;
            var width = img.width;
            var warnings = [], errors = [];
            if(height - width !== 0) {
              warnings.push('Image height and width are not equal.  Stone images work best if they are square.');
            }
            if(height > 3840 || width > 3840) {
              warnings.push('Image dimensions are exceeding 3840 pixels in either height or width');
            }
            if(theFile.size > 4194304) {
              errors.push('Image size is exceeding 4MB in size.');
            }
            if(errors.length > 0) {
              this.props.showErrorBox('Unable to use Image', errors.join('<br />'));
            } else {
              if(warnings.length > 0) {
                this.props.showMessageBox("Image Warning", warnings.join("<br />"));
              }
              (warnings.length > 0 ? this.props.showMessageBox("Image Warning", warnings.join("<br />")) : Promise.resolve())
                .then(() => this.props.showImageUploadNotice(e.target.result))
                .then(() => {
                  // Render thumbnail.
                  this.props.onUpdateTransientField('imageName', theFile.name);
                  this.props.onUpdateTransientField('thumbUrl', e.target.result);
                  this.props.onUpdateTransientField('imageUrl', e.target.result);
                  this.props.onUpdateTransientField('clearImage', false);
                  this.setState({
                    'image': e.target.result,
                    'clearImage': false,
                    'showReset': true
                  });
                }).catch(() => {
                  //do nothing, catch handles no click
                });
            }
          }
          if(e.target.result) {
            img.src = e.target.result;
          } else {
            this.props.showErrorBox("Unable to use Image", "Unrecognized image format, please use a JPEG or PNG image.");
          }
        }.bind(this);
      }.bind(this))(f);

      // Read in the image file as a data URL.
      reader.readAsDataURL(f);
    }
  }

  handleIsInMasterCheck(checked) {
    this.setState({setAsMaster: !checked});
    this.props.onUpdateTransientField("setAsMaster", !checked);
  }

  setAcceptIncomingChanges = () => {
    this.setState({acceptIncomingChanges: true});
  }

  componentDidMount() {
    //forceCheck();
    //document.getElementsByTagName('section')[0].addEventListener("scroll", forceCheck);
    document.addEventListener("transientUpdatesCleared", this.setAcceptIncomingChanges);
  }

  componentWillUnmount() {
    document.removeEventListener("transientUpdatesCleared", this.setAcceptIncomingChanges);
    //document.getElementsByTagName('section')[0].removeEventListener("scroll", forceCheck);
  }

  componentDidUpdate(props) {
    if(this.state.acceptIncomingChanges === true) {
      this.setState({
        enabled: (props.stone.fabricatorStoneData && props.stone.fabricatorStoneData.enabled),
        price: this.getPrice(props.stone) || 0,
        image: this.getStoneImage(props.stone),
        name: this.getStoneName(props.stone),
        imageUrl: props.stone.imageUrl,
        thumbUrl: props.stone.thumbUrl,
        showReset: (props.stone.fabricatorStoneData && props.stone.fabricatorStoneData.imageKey),
        isOwner: props.AR.isMe(props.stone.createdById, false),
        acceptIncomingChanges: false
      });
    }
  }

  render = template
}

StoneSetupCardComponent.propTypes = {
  stone: PropTypes.object.isRequired,
  onUpdateTransientField: PropTypes.func.isRequired
};

const StoneSetupCard = connect(mapStateToProps, mapDispatchToProps)(StoneSetupCardComponent);

export { StoneSetupCard };
